import { Injectable } from '@angular/core';
import {NgForage} from 'ngforage';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PanelStateService {
  public panelStates = new BehaviorSubject<any>({ left: 'full', right: 'full'});
  public overrides = new BehaviorSubject<{ [side: string]: string }>({});
  private released = new Set<string>();

  constructor(private ngForage: NgForage) {
    this.ngForage.getItem('panelStates').then((value) => {
      if (value != null) {
        this.panelStates.next(value);
      }
    });
  }

  setState(side: string, state: string) {
    const states = this.panelStates.value;
    states[side] = state;
    this.panelStates.next(states);
    this.ngForage.setItem('panelStates', states);
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 0);
  }

  override(side: string, state: string) {
    const overrides = {...this.overrides.value};
    if (state && this.released.has(side)) {
      return;
    }
    if (overrides[side] === state || (!state && !(side in overrides))) {
      return;
    }
    if (state) {
      overrides[side] = state;
    } else {
      delete overrides[side];
    }
    this.overrides.next(overrides);
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 0);
  }

  toggleState(side: string) {
    if (this.overrides.value[side]) {
      this.released.add(side);
      this.override(side, null);
      return;
    }
    if (this.panelStates.value[side] === 'full') {
      this.setState(side, 'small');
    } else if (this.panelStates.value[side] === 'small') {
      this.setState(side, 'hidden');
    } else if (this.panelStates.value[side] === 'hidden') {
      this.setState(side, 'full');
    }
  }

}
